import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getRouteVideo } from '../../redux/staticSlice';
import contentNotFoundImg from '../../assets/image-not-found.jpg';

export const VideoPlayer = ({type, name, promoterId, routeId}) => {
    const dispatch = useDispatch();

    const video = useSelector((state) => state.static.videos.find(v => v.name === name && v.type === type));
    const videoRef = useRef(null);

    useEffect(() => {
        if (!video) {
            dispatch(getRouteVideo({type, name, promoterId, routeId}))
        }
    }, [type, name]);
    useEffect(() => {
        if (videoRef?.current) {
            videoRef.current.src = video?.src;
        }
    }, [video])

    if (video && !video.src) {
        return <img src={contentNotFoundImg} alt="" />
    }

    return (
        <video ref={videoRef} autoPlay width="600" controls>
            Ваш браузер не поддерживает видео-тег.
        </video>
    );
};
